import { Component, OnInit, ViewChild } from "@angular/core";
import {
  DialogService,
  DynamicDialogRef,
  DynamicDialogConfig,
} from "primeng/dynamicdialog";
import { CBLService } from "src/app/servicios/cbl.service";
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
} from "@angular/common/http";
import { Respuesta } from "src/app/libs/respuesta";
import { formatDate } from "@angular/common";
import { Misdocumentos, Documento } from "src/app/libs/dataObjects";
import { MessageService, SelectItem } from "primeng/api";
import { FileUpload } from "primeng/fileupload";
import { SafeUrl, DomSanitizer } from "@angular/platform-browser";
import { GlobaldataService } from "src/app/servicios/globaldata.service";
import { FormsModule } from "@angular/forms";
import { Inject } from "@angular/core";
import { FormBuilder, FormGroup, FormArray, Validators } from "@angular/forms";
// import { DynamicDialogRef } from 'primeng/dynamicdialog';
@Component({
  selector: "app-popup",
  templateUrl: "./popup.component.html",
  styleUrls: ["./popup.component.scss"],
})
export class PopupComponent implements OnInit {
  header: any;
  popup_name: any;
  data: any;
  leaveType: string;
  leaveValue: number;
  permisosForm: FormGroup;
  loading: boolean = false;
  leaveForm: FormGroup;
  constructor(
    private fb: FormBuilder,
    public cbl: CBLService,
    private messageService: MessageService,
    private httpClient: HttpClient,
    public dialogService: DialogService,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public sanitizer: DomSanitizer,
    public gds: GlobaldataService
  ) {
    // let id = this.config.data.id;
    // console.log(this.config.data);
    this.leaveForm = this.fb.group({
      type: [""],
      value: [""],
      idtipopermiso: [0],
    });
    let header = this.config.data.header;
    this.popup_name = this.config.data.popup_name;
    this.data = this.config.data.data;
    this.header = header;
  }

  ngOnInit(): void {
    if (this.popup_name === "employeeLeaveAction") {
      this.permisosForm = this.fb.group({
        data: this.fb.array(
          this.data.map((p) =>
            this.fb.group({
              idtipopermiso: [p.idtipopermiso],
              permiso: [p.permiso],
              value: [p.value],
            })
          )
        ),
      });
    }
  }
  get permisosArray() {
    return this.permisosForm.get("data") as FormArray;
  }

  onSubmit() {
    console.log(this.permisosForm.value);
    // You can POST this to your backend
  }
  close() {
    this.ref.close(); // return nothing
  }

  submit() {
    const currentData = this.permisosForm.value.data;
    const updatedData = currentData.filter((item, index) => {
      const original = this.data[index];
      return item.value !== original.value;
    });
    console.log("Updated permisos:", updatedData);
    this.ref.close(updatedData); // return user input
  }
  addNewLeaveType() {
    if (this.leaveForm.valid) {
      console.log("Form Values:", this.leaveForm.value);
      const form_data = {
        type: this.leaveForm.get("type")?.value,
        value: this.leaveForm.get("value")?.value,
        idCliente: this.data["idCliente"],
        idEmpleado: this.data["idEmpleado"],
        idtipopermiso: this.leaveForm.get("idtipopermiso")?.value,
      };
      console.log("form_data: ", form_data);
      this.httpClient
        .post(`${this.gds.urlBaseDL}/empleado/update_leave_type`, form_data)
        .toPromise()
        .then((res) => {
        this.messageService.add({
          severity: "info",
          summary: "Permisos actualizar",
          detail: res['message'],
        });
          this.ref.close();
        })
        .catch((error) => {
          const errorMessage =
            error?.error?.message ||
            "No se pudo agregar el tipo de permiso. Inténtelo de nuevo.";

          this.messageService.add({
            severity: "error",
            summary: "Error",
            detail: errorMessage,
          });
          console.log(error);
        });
    } else {
      console.log("Form Invalid");
    }
    // this.leaveForm.get("type").setValue("");
    // this.leaveForm.get("value").setValue("");
  }
  reset() {
    this.leaveForm.get("type").setValue("");
    this.leaveForm.get("value").setValue("");
    this.leaveForm.get("idtipopermiso").setValue(0);
  }
  getCustomLeave(value: string) {
    console.log(value);
    const leave_data = this.config.data?.data?.filter(
      (leave) => leave.idtipopermiso == value && leave.idCliente != null
    );
    if (leave_data?.length > 0) {
      this.leaveForm.get("type").setValue(leave_data[0]["permiso"]);
      this.leaveForm.get("value").setValue(leave_data[0]["value"]);
      this.leaveForm
        .get("idtipopermiso")
        .setValue(leave_data[0]["idtipopermiso"]);
    } else {
      this.leaveForm.get("type").setValue("");
      this.leaveForm.get("value").setValue("");
      this.leaveForm.get("idtipopermiso").setValue(0);
    }
    console.log(leave_data);
  }
  deleteLeaveType() {
    const form_data = {
      type: this.leaveForm.get("type")?.value,
      value: this.leaveForm.get("value")?.value,
      idCliente: this.data["idCliente"],
      idEmpleado: this.data["idEmpleado"],
      idtipopermiso: this.leaveForm.get("idtipopermiso")?.value,
    };
    this.loading = true;
    this.httpClient
      .post(`${this.gds.urlBaseDL}/empleado/delete_leave_type`, form_data)
      .toPromise()
      .then((res) => {
        this.data = res;
        this.loading = false;
        this.messageService.add({
          severity: "info",
          summary: "Permisos actualizar",
          detail: res['message'],
        });
        this.ref.close();
      })
      .catch((error) => {
        const errorMessage =
          error?.error?.message ||
          "No se pudo eliminar el tipo de permiso. Inténtalo de nuevo.  ";

        this.messageService.add({
          severity: "error",
          summary: "Error",
          detail: errorMessage,
        });
        console.log(error);
      });
    this.loading = false;
  }
}
